<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import ShiftDetail from '../../../../shifts/components/ShiftDetail.vue'
import { ShiftID } from '../../../../shifts/models/shift'

definePage({
    props: true,
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        childNavItems: [
            {
                label: 'Shifts',
                route: '/(app)/schedule/shifts/',
            },
            {
                label: 'New Shift',
                route: '/(app)/schedule/shifts.wizard',
            },
            {
                label: 'Activity',
                route: '/(app)/schedule/activity/',
            },
            {
                label: 'Calendar',
                route: '/(app)/schedule/calendar/',
            }
        ],
    }
})

const {
  id,
} = defineProps<{
    id: ShiftID
}>()
</script>

<template>
  <ShiftDetail
    :id="id"
  />
</template>